import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import permission from './modules/permission';
import settings from './modules/settings';
import user from './modules/user';
import event from './modules/event';
import common from './modules/common';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    permission,
    settings,
    user,
    event,
    common,
  },

  plugins: [
    createPersistedState({paths: ["user", "permission", "settings"]
    })
  ],

  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
